import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { AllergyCodeDetailsFilter } from 'src/app/core/Models/interfaces/master-management/payloads/allergyCodeDetailsFilter';
import { AllergyCodeListFiltter } from 'src/app/core/Models/interfaces/master-management/payloads/allergyCodeListFiltter';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class AllerrgyCodeService {

constructor(private http: HttpClient) { }

public getAllergyCodeList(filterPayload: AllergyCodeListFiltter): Observable<ApiResponse> {
  const endpoint = getApiUrl(apiList.allergy.getAllergyList, filterPayload);
  return this.http.get<ApiResponse>(endpoint)
}

public getAllergyCodeDetails(filterPayload: AllergyCodeDetailsFilter): Observable<ApiResponse> {
  const endpoint = getApiUrl(apiList.allergy.getAllergyDetails, filterPayload);
  return this.http.get<ApiResponse>(endpoint);
}

public updateAllergy(filterPayload: { validityStart: string, validityEnd: string }, id: number): Observable<ApiResponse>  {
  const endpoint=getApiUrl(apiList.allergy.updateAllergyCode,filterPayload,{id});
  return this.http.put<ApiResponse>(endpoint,'')
}

}
